import { render, staticRenderFns } from "./RoomColorPicker.vue?vue&type=template&id=6b5e1ea8&"
import script from "./RoomColorPicker.vue?vue&type=script&lang=js&"
export * from "./RoomColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./RoomColorPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports